import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ServiceService } from 'src/app/services/service/service.service';

@Component({
  selector: 'app-search-pagedesign',
  templateUrl: './search-pagedesign.page.html',
  styleUrls: ['./search-pagedesign.page.scss'],
})
export class SearchPagedesignPage implements OnInit {
  searchValue:any;
  allServices:any;
  constructor( 
    private navCtrl:NavController,
    private service:ServiceService
    ) { }

  ngOnInit() {
  }

  searchDataBase(){
    console.log(this.searchValue);
    let locationId = localStorage.getItem('locationId');

    let filter =  {		
    
      "where":{
        "service_Name":{"like":this.searchValue,"options":"i"},
        "status":true ,
        "areaId":{"like":location}
      },
      "include":[
        {
          "relation":'subServices',
          "scope":{
            "fields":["id","service_Name","serviceBannerImage","measureableUnitId"],
            "where":{
              "status":true,
            },
            "limit":1
            // "include":{
            //   "relation":"subServices",
            //   "scope":{
            //     "fields":["id","service_Name","serviceBannerImage","measureableUnitId"],
            //     "where":{
            //       "status":true,
            //       "areaId":{"like":location}
            //     },  
            //   }
            // }
          }
        }
      ],
      "fields":["id","service_Name","sequence","subServices","measureableUnitId","serviceBannerImage"],
      "order": "sequence DESC"

    };

    this.service.searchServices(filter).then((res)=>{
      console.log(res);
      this.allServices = res;
    })
  }
  goback(){
    this.navCtrl.navigateBack('/app/home');
  }

  selectService(service){
    console.log(service);
    let place = localStorage.getItem('location');

    if(service.subServices && service.subServices.length > 0){
      console.log("nextpage",place);
      this.navCtrl.navigateForward("/subservice/"+service.service_Name);
    }else{
      let data = {
        "serviceId":service.id,
        "service":service,
        "city":place,
        "locationId":localStorage.getItem("locationId"),
        "serviceName":service.service_Name,
        "measureableUnit":service.measureableUnitId
      }
      localStorage.setItem('JobData',JSON.stringify(data));
      if(service.measureableUnitId && service.measureableUnitId[0] && service.measureableUnitId[0] !== null ){
        this.navCtrl.navigateForward('/choose-functionality');
      }else{
        this.navCtrl.navigateForward('/service-detail');
      }
    }
  }
}






